/**
 * Drapeau officiel du Bénin :
 *   - Bande verticale VERTE à gauche (~2/5 de la largeur)
 *   - Bande horizontale JAUNE en haut à droite
 *   - Bande horizontale ROUGE en bas à droite
 * Ratio officiel 2:3.
 */
export const BeninFlag = ({ className = "h-4 w-6" }) => (
  <svg
    viewBox="0 0 30 20"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Drapeau du Bénin"
    role="img"
    preserveAspectRatio="none"
  >
    <rect width="30" height="20" fill="#FCD116" />
    <rect x="12" y="10" width="18" height="10" fill="#E8112D" />
    <rect width="12" height="20" fill="#008751" />
  </svg>
);

// Small stylized flag for placeholder countries (3 vertical stripes).
export const SimpleFlag = ({ colors, className = "h-4 w-6" }) => (
  <span
    className={`inline-flex overflow-hidden rounded-[2px] border border-black/5 ${className}`}
    aria-hidden="true"
  >
    {colors.map((c, i) => (
      <span key={i} className="flex-1" style={{ background: c }} />
    ))}
  </span>
);
